import { render, staticRenderFns } from "./sbpPaymentModal.vue?vue&type=template&id=203eda5a"
import script from "./sbpPaymentModal.vue?vue&type=script&lang=js"
export * from "./sbpPaymentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports